namespace Matrix.Data {
    export interface ListForm {
        ListCode: Serenity.StringEditor;
        ListName: Serenity.StringEditor;
        ListType: Serenity.StringEditor;
        Items: ListItemGrid;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class ListForm extends Serenity.PrefixedContext {
        static formKey = 'Data.List';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ListForm.init)  {
                ListForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = ListItemGrid;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(ListForm, [
                    'ListCode', w0,
                    'ListName', w0,
                    'ListType', w0,
                    'Items', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
